import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { capitalizeFirstLetter } from '../../helper/unit-helper';
import './styles.scss';

class InputEditAble extends Component {
  static propTypes = {
    changeTextArea: PropTypes.bool,
    disableButtonEdit: PropTypes.bool,
    onSubmit: PropTypes.func,
    inputName: PropTypes.string,
    errorMsg: PropTypes.string,
    className: PropTypes.any,
    defaultValue: PropTypes.string,
    buttonSize: PropTypes.string,
    ignoreRequired: PropTypes.bool,
    isCapitalize: PropTypes.bool,
    placeholder: PropTypes.string,
    onCancel: PropTypes.func,
    autoFocus: PropTypes.bool,
    actionButtonPosition: PropTypes.string,
    ignoreOnBlur: PropTypes.bool,
    style: PropTypes.object,
    validEmail: PropTypes.bool,
    maxLength: PropTypes.string,
    enableFocusOut: PropTypes.bool
  };

  static defaultProps = {
    className: '',
    enableFocusOut: false,
    defaultValue: undefined,
    inputName: 'input-edit-able',
    ignoreRequired: false,
    placeholder: '',
    actionButtonPosition: 'bottom',
    validEmail: false,
    maxLength: '40'
  };

  constructor(props) {
    super(props);
    this.state = {
      inputEditAble: false,
      inputValue: {
        [props.inputName]: props.defaultValue
      },
      errorMsg: props.errorMsg
    };
  }

  componentDidMount() {
    this.props.enableFocusOut && this.onClickOutSideToCancel();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.props.defaultValue) {
      this.setState({
        inputValue: {
          [this.props.inputName]: nextProps.defaultValue
        }
      });
    }

    this.setState({
      errorMsg: nextProps.errorMsg
    });
  }

  onClickOutSideToCancel = () => {
    window.addEventListener('click', e => {
      if (
        document.getElementById('wrapper-input-edit-able') &&
        document.getElementById('wrapper-input-edit-able').contains(e.target)
      ) {
        // Clicked in box
      } else {
        if (this.state.errorMsg) {
          this.onCancel();
        }
      }
    });
  }
  onSubmit = () => {
    const { inputName, defaultValue, ignoreRequired } = this.props;

    const { errorMsg, inputValue } = this.state;

    if (!ignoreRequired && !inputValue[inputName].trim()) {
      return;
    }

    if (errorMsg) {
      return;
    }

    if (defaultValue !== inputValue[inputName].trim()) {
      const value = {
        ...inputValue,
        [inputName]: inputValue[inputName].trim()
      };

      this.props.onSubmit(value);
    } else {
      this.onCancel();
    }
  };

  onCancel = () => {
    this.setState(
      {
        inputEditAble: false,
        errorMsg: null,
        inputValue: {
          [this.props.inputName]: this.props.defaultValue
        }
      },
      () => {
        if (this.props.onCancel) {
          this.props.onCancel();
        }
      }
    );
  };

  validatorEmail = emailString => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;

    if (!emailPattern.test(emailString.trim())) {
      return false;
    }

    return true;
  };

  onChangeInput = e => {
    e.preventDefault();

    const { validEmail } = this.props;

    const { value } = e.target;

    const valueTrim = value.trim();

    if (e.target && valueTrim) {
      if (validEmail) {
        if (this.validatorEmail(value)) {
          this.setState({
            inputValue: {
              [this.props.inputName]: value
            },
            errorMsg: null
          });
        } else {
          this.setState({
            inputValue: {
              [this.props.inputName]: value
            },
            errorMsg: 'Invalid email'
          });
        }
      } else {
        this.setState({
          inputValue: {
            [this.props.inputName]: value
          },
          errorMsg: null
        });
      }
    } else {
      if (!this.props.ignoreRequired) {
        this.setState({
          inputValue: {
            [this.props.inputName]: value
          },
          errorMsg: this.props.errorMsg || 'This field is required'
        });
      } else {
        this.setState({
          inputValue: {
            [this.props.inputName]: value
          }
        });
      }
    }
  };

  onBlurInput = () => {
    if (!this.props.ignoreOnBlur) {
      if (
        this.state.inputValue[this.props.inputName] === undefined ||
        this.props.defaultValue ===
          this.state.inputValue[this.props.inputName].trim()
      ) {
        this.setState({
          inputEditAble: false,
          errorMsg: null,
          inputValue: {
            [this.props.inputName]: this.props.defaultValue
          }
        });
        if (this.props.onCancel) {
          this.props.onCancel();
        }
      } else {
        if (!this.state.errorMsg) {
          this.setState(
            {
              inputEditAble: false
            },
            () => {
              this.onSubmit();
            }
          );
        }
      }
    }
  };

  render() {
    let value = this.state.inputValue[this.props.inputName];
    if (value === undefined) {
      if (this.props.isCapitalize) {
        value = this.props.defaultValue
          ? capitalizeFirstLetter(this.props.defaultValue)
          : '';
      } else {
        value = this.props.defaultValue ? this.props.defaultValue : '';
      }
    } else {
      if (this.props.isCapitalize) {
        value = capitalizeFirstLetter(value); //.trim();
      }
    }
    return (
      <div>
        <div className='wrapper-input-edit-able'>
          {this.props.changeTextArea ? <textarea
            type='text'
            key={this.props.inputName}
            className={`form-control ${this.props.className}`}
            value={value}
            placeholder={this.props.placeholder}
            maxLength={this.props.maxLength}
            onChange={this.onChangeInput}
            onFocus={this.props.disableButtonEdit ? () => this.setState({ inputEditAble: false }) : () => this.setState({ inputEditAble: true })}
            onBlur={this.onBlurInput}
            name={this.props.inputName}
            autoFocus={this.props.autoFocus ? true : false}
            style={this.state.errorMsg ? { borderColor: 'red' } : {}}
          /> : <input
            type='text'
            key={this.props.inputName}
            className={`form-control ${this.props.className}`}
            value={value}
            placeholder={this.props.placeholder}
            maxLength={this.props.maxLength}
            onChange={this.onChangeInput}
            onFocus={this.props.disableButtonEdit ? () => this.setState({ inputEditAble: false }) : () => this.setState({ inputEditAble: true })}
            onBlur={this.onBlurInput}
            name={this.props.inputName}
            autoFocus={this.props.autoFocus ? true : false}
            style={this.state.errorMsg ? { borderColor: 'red' } : {}}
          />}
          {this.state.inputEditAble && [
            <button
              key='cancel'
              className={`input-edit-able input-edit-able-cancel input-over-btn ${this.props.actionButtonPosition}`}
              onMouseDown={this.onCancel}
            >
              <i className={'fa fa-close'} />
            </button>,
            <button
              key='save'
              className={`input-edit-able input-edit-able-save input-over-btn ${this.props.actionButtonPosition}`}
              onClick={this.onSubmit}
            >
              <i className={'fa fa-check'} />
            </button>
          ]}
        </div>

        {this.state.errorMsg && (
          <span className='cls-danger help-block'>{this.state.errorMsg}</span>
        )}
      </div>
    );
  }
}

export default InputEditAble;



// WEBPACK FOOTER //
// ./src/components/inputEditAble/index.js